import React from "react";
const CollapsibleListContext = React.createContext(
  null
);
const CollapsibleListContextProvider = ({
  expandedItemId,
  setExpandedItemId,
  children
}) => {
  return /* @__PURE__ */ React.createElement(CollapsibleListContext.Provider, { value: { expandedItemId, setExpandedItemId } }, children);
};
export {
  CollapsibleListContext,
  CollapsibleListContextProvider
};
//# sourceMappingURL=collapsibleListContext.js.map
